// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateNonTrackedPinModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_CLAIM_INCENTIVE_CREATE_PIN_MODAL_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/incentive/action-creators/non-tracked-pin-modal-visibility.js